<template>
    <div class="container news-container">
            <div v-if="condition.isLoadArticles" class="row">
                <preview-loader v-for="index in 3" :key="index"></preview-loader>
            </div>
        <div class="row" v-else-if="articles && articles.length > 0">
          <div v-for="article in articles" :key="article.id" class="col-lg-3 col-md-6 mb-3 pr-2 pl-2">
            <div class="article" @click="showNews(article.slug)">
              <div class="preview" :style="'background-image:url('+ article.previewImageUrl +')'"></div>
<!--              <img class="preview" :src="article.previewImageUrl" alt="">-->
              <div class="info">
                <div class="title">{{ article.title }}</div>
                <div v-html="article.description" class="description"></div>
                <div v-if="article.isDisableForPartner">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8" fill="#FFDDDB"/>
                    <rect x="7" y="3" width="2" height="6" fill="#EF4236"/>
                    <rect x="7" y="11" width="2" height="2" fill="#EF4236"/>
                  </svg>
                  Ця новина не відображається для ваших партнерів
                </div>
              </div>
              <div class="publish-date mt-2">
                {{ article.publishedAt }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-notification__text">
            <p>Тут будуть з`являтися новини</p>
        </div>
        <Divider type="horizontal" />

        <div class="d-flex justify-between">
          <div>
            <PaginateButton v-if="listQuery.page !== 1" @click="initList(listQuery.page - 1)">Попередній</PaginateButton>
          </div>
          <div>Сторінка {{ listQuery.page }} з {{ lastPage }}</div>
          <div>
            <PaginateButton v-if="listQuery.page !== lastPage" @click="initList(listQuery.page + 1)">Наступний</PaginateButton>
          </div>
        </div>
    </div>
</template>

<script>

import Pagination from '@/components/Pagination';
import preview from './components/preview';
import { list as articleList } from '@/api/article';
import { userViewedNews } from '@/api/news';
import previewLoader from './components/previewLoader';
import {Divider} from "@/shared/ui/divider";
import PaginateButton from "@/components/ui/Table/components/PaginateButton.vue";

export default {
    components: {
      PaginateButton,
      Divider,
        previewLoader,
        preview,
        Pagination
    },
    data: function () {
        return {
            total: 10,
            lastPage: 0,
            condition: {
                isLoadArticles: true,
            },
            listQuery: {
                page: 1,
                limit: 12,
            },
            articles: {},
        }
    },
    created:  function() {
        this.initList();
        userViewedNews();
        this.$store.commit('SET_COUNT_NOT_VIEWED_NEWS', 0);
    },
    methods: {
        showNews(slug) {
          this.$router.push({name: 'newShow', params: {slug: slug}})
        },
        initList(page = null) {
          if (page) {
            this.listQuery.page = page;
          }
          articleList(this.listQuery).then((response) => {
            this.articles = response.data.data
            this.total = response.data.meta.total
            this.lastPage = response.data.meta.last_page
            this.condition.isLoadArticles = false;
          });
        }
    }
}
</script>
<style lang="scss" scoped>
.article {
  cursor: pointer;
  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;

  border: 1px solid #E2E8F0;
  /* Box Shadow/shadow */
  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  border-radius: 8px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
  height: 100%;

  .title {
    /* Text-sm/Medium */
    font-family: 'Geist',serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    color: #09090B;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;
  }
  .description {
    /* Text */
    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0;
    gap: 10px;
    /* Inside auto layout */
    flex: none;
    align-self: stretch;
    flex-grow: 0;
    /* Text-sm/Medium */
    font-family: 'Geist',serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */
    color: #09090B;
    /* Inside auto layout */
    flex: none;
    flex-grow: 1;
  }
}

.publish-date {
  /* Text-xs/Regular */
  font-family: 'Geist',serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  color: #71717A;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;

}
.preview {
  min-height: 150px;
  height: 150px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;

  img {
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: right bottom;
    object-position: right bottom;
  }
}

</style>
